const invitation = {
    find_your_tenants: 'ค้นหาผู้เช่าของคุณ',
    find_tenants_description: 'ที่อยู่อีเมลของคุณอาจลงทะเบียนกับผู้เช่าหลายรายแล้ว คุณสามารถเลือกเข้าร่วมกับผู้เช่าที่มีอยู่หรือดำเนินการสร้างผู้เช่าใหม่ต่อ',
    create_new_tenant: 'สร้างผู้เช่ารายใหม่',
    email_not_match_title: 'คุณเข้าสู่ระบบด้วย\n{{email}}',
    email_not_match_description: 'กรุณาเข้าสู่ระบบด้วยบัญชีที่ถูกต้องเพื่อรับคำเชิญและเป็นสมาชิกขององค์กร',
    switch_account: 'เข้าสู่ระบบด้วยบัญชีอื่น',
    invalid_invitation_status: 'คำเชิญไม่ถูกต้อง กรุณาติดต่อผู้ดูแลระบบและลองใหม่อีกครั้ง',
    invitation_not_found: 'ไม่พบคำเชิญ กรุณาติดต่อผู้ดูแลระบบ',
};
export default Object.freeze(invitation);
